/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TemplateTypeEnum } from './templateTypeEnum';
import { TemplateTenantApiModel } from './templateTenantApiModel';


export interface TemplateApiModel { 
    templateId: number;
    templateName: string;
    type: TemplateTypeEnum;
    tenants: Array<TemplateTenantApiModel>;
    isOverriden: boolean;
}
export namespace TemplateApiModel {
}


